import {
    Button,
    Card,
    HorizontalContainer,
    HtmlView,
    VerticalContainer,
} from '@/components';
import { R } from '@/features/pfaPhysiotherapy/resources/PfaPhysiotherapyResources.resx';
import { PfaLogoIcon } from '@/components/Icons';
import { Utils } from '@/shared/Utils';

type ConsentProps = {
    onAccept: () => void;
};

export const Consent = ({ onAccept }: ConsentProps) => {
    return (
        <Card alwaysCard={false}>
            <VerticalContainer spacing="md">
                <PfaLogoIcon className="mb-2 w-24" />
                <h2>{R.ConsentHeader}</h2>
                <HtmlView
                    className="max-w-none whitespace-pre-line"
                    html={Utils.decodeHtml(R.ConsentDescription)}
                />
            </VerticalContainer>
            <HorizontalContainer className="mt-6 justify-end">
                <Button variant="primary" onClick={onAccept}>
                    {R.Next}
                </Button>
            </HorizontalContainer>
        </Card>
    );
};
